import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";

import "../assets/styles/Faq.scss";
import arrowIcon from "../assets/images/icons/infoArrowDown.svg";

import healthCoachBanner from "../assets/images/health-coach-banner.png";
import howToJoinBanner from "../assets/images/faq-how-to-join.png";
import rocheBanner from "../assets/images/faq-banner-2.png";
import mogBanner from "../assets/images/faq-banner-3.png";
import TestimonialCarousel from "./TestimonialCarousel";

function Faq() {
  return (
    <div className="faq-container">
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col sm={4}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  BookDoc Health Coaching Programme
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">
                  Roche Accu-Chek® Guide Me Offer
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="third">
                  MOG 6-in-1 Vision Experience
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <div className="text-start pb-2 title-row">
                  <div className="badge bonus">BONUS 1</div>3 Months BookDoc
                  Health Coaching Programme
                </div>
                <img
                  className="w-100 img-fluid"
                  src={healthCoachBanner}
                  alt="healh-coach-banner"
                />
                <div className="card-wrapper content-cc">
                  <div className="faq-card">
                    <main className="faq-content">
                      <div className="faq-articles">
                        <article className="faq-accordion">
                          <input
                            type="checkbox"
                            className="tgg-title"
                            id="tgg-title-1"
                            defaultChecked
                          />
                          <div className="faq-accordion-title">
                            <label htmlFor="tgg-title-1">
                              How to join the Health Coaching Programme?
                              <span className="arrow-icon">
                                <img src={arrowIcon} alt="arrow-icon" />
                              </span>
                            </label>
                          </div>
                          <div className="faq-accordion-content">
                            <div className="paragraph">
                              <img
                                className="w-100 img-fluid"
                                src={howToJoinBanner}
                                alt="how-to-join-banner"
                              />
                            </div>
                          </div>
                        </article>

                        <article className="faq-accordion">
                          <input
                            type="checkbox"
                            className="tgg-title"
                            id="tgg-title-2"
                          />
                          <div className="faq-accordion-title">
                            <label htmlFor="tgg-title-2">
                              What does the Health Coaching Programme include?
                              <span className="arrow-icon">
                                <img src={arrowIcon} alt="arrow-icon" />
                              </span>
                            </label>
                          </div>
                          <div className="faq-accordion-content">
                            <div className="paragraph">
                              <ul
                                style={{
                                  listStyleType: "disc",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <li className="content">
                                  <span className="content-title">
                                    Personalised Coaching:{" "}
                                  </span>
                                  You’ll receive three months of personalised
                                  support from a dedicated dietitian to help you
                                  manage your blood sugar levels and reduce your
                                  risk of diabetes.
                                </li>
                                <li className="content">
                                  <span className="content-title">
                                    Blood Sugar Control:{" "}
                                  </span>
                                  You’ll receive a customised action plan from
                                  your coach, covering nutrition, exercise, and
                                  medication to support your long‑term health.
                                </li>
                                <li className="content">
                                  <span className="content-title">
                                    Traffic Light Food Rating System:{" "}
                                  </span>
                                  Log your meals and make healthier choices with
                                  simple colour cues — with{" "}
                                  <span className="green">Green</span> foods to
                                  enjoy more often,{" "}
                                  <span className="yellow">Yellow</span> in
                                  moderation, and{" "}
                                  <span className="red">Red</span> to limit.
                                </li>
                                <li className="content">
                                  <span className="content-title">
                                    Reward-based Step Tracking:{" "}
                                  </span>
                                  Track your daily steps to stay active and earn
                                  rewards along the way.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </article>

                        <article className="faq-accordion">
                          <input
                            type="checkbox"
                            className="tgg-title"
                            id="tgg-title-3"
                          />
                          <div className="faq-accordion-title">
                            <label htmlFor="tgg-title-3">
                              What are the benefits of the Health Coaching
                              Programme?
                              <span className="arrow-icon">
                                <img src={arrowIcon} alt="arrow-icon" />
                              </span>
                            </label>
                          </div>
                          <div className="faq-accordion-content">
                            <div className="paragraph">
                              <ul
                                style={{
                                  listStyleType: "disc",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <li className="content">
                                  <span className="content-title">
                                    Better Health Outcomes:{" "}
                                  </span>
                                  Facilitates meaningful lifestyle changes that
                                  improve blood sugar control and reduce health
                                  risks.
                                </li>
                                <li className="content">
                                  <span className="content-title">
                                    Holistic Wellness:{" "}
                                  </span>
                                  Addresses the physical, emotional, and
                                  behavioural aspects of health for
                                  comprehensive well-being.
                                </li>
                                <li className="content">
                                  <span className="content-title">
                                    Enhanced Accountability:{" "}
                                  </span>
                                  Continuous support from a dietitian helps you
                                  to overcome obstacles and stay on track.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </article>
                      </div>
                      <div className="testimonial-container w-100">
                        <TestimonialCarousel />
                      </div>
                    </main>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <div className="text-start pb-2 title-row">
                  <div className="badge badge-pill bonus">BONUS 2</div>
                  Roche Accu-Chek® Guide Me Offer{" "}
                </div>
                <img
                  className="w-100 img-fluid"
                  src={rocheBanner}
                  alt="roche-banner"
                />
                <div className="card-wrapper content-cc">
                  <div className="faq-card">
                    <main className="faq-content">
                      <div className="faq-articles">
                        <article className="faq-accordion">
                          <input
                            type="checkbox"
                            className="tgg-title"
                            id="tgg-title-2-1"
                            defaultChecked
                          />
                          <div className="faq-accordion-title">
                            <label htmlFor="tgg-title-2-1">
                              Track your blood sugar with confidence
                              <span className="arrow-icon">
                                <img src={arrowIcon} alt="arrow-icon" />
                              </span>
                            </label>
                          </div>
                          <div className="faq-accordion-content">
                            <div className="paragraph">
                              <div className="content">
                                Monitoring your blood sugar regularly is a vital
                                part of understanding your health and preventing
                                complications. With this special offer, you’ll
                                receive{" "}
                                <span className="bold">
                                  RM10 off the Accu-Chek® Guide Me Kit{" "}
                                </span>{" "}
                                — an easy-to-use blood glucose meter — when you
                                purchase in-store at participating Health Lane
                                Family Pharmacy outlets.
                                <br />
                                <br />
                                Whether you're newly diagnosed or keeping tabs
                                on your sugar levels, this device makes
                                self-monitoring simple and accessible.
                              </div>
                            </div>
                          </div>
                        </article>

                        <article className="faq-accordion">
                          <input
                            type="checkbox"
                            className="tgg-title"
                            id="tgg-title-2-2"
                          />
                          <div className="faq-accordion-title">
                            <label htmlFor="tgg-title-2-2">
                              Why it matters
                              <span className="arrow-icon">
                                <img src={arrowIcon} alt="arrow-icon" />
                              </span>
                            </label>
                          </div>
                          <div className="faq-accordion-content">
                            <div className="paragraph">
                              <div className="content">
                                <ul
                                  style={{
                                    listStyleType: "disc",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <li style={{ display: "list-item" }}>
                                    Quick and reliable readings at home.
                                  </li>
                                  <li style={{ display: "list-item" }}>
                                    Helps you track patterns and progress.
                                  </li>
                                  <li style={{ display: "list-item" }}>
                                    Empowers you to make informed choices
                                    alongside diet and activity changes.
                                  </li>
                                </ul>
                              </div>
                              <div className="content">
                                This exclusive offer is made possible through
                                our partnership with{" "}
                                <span className="bold">Roche Malaysia</span>,
                                supporting you in your journey towards better
                                health.
                              </div>
                            </div>
                          </div>
                        </article>
                      </div>
                    </main>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                <div className="text-start pb-2 title-row">
                  <div className="badge badge-pill bonus">BONUS 3</div>
                  MOG 6-in-1 Vision Experience
                </div>
                <img
                  className="w-100 web-view img-fluid"
                  src={mogBanner}
                  alt="mog-banner"
                />
                <article className="faq-accordion">
                  <input
                    type="checkbox"
                    className="tgg-title"
                    id="tgg-title-3-1"
                    defaultChecked
                  />
                  <div className="faq-accordion-title">
                    <label htmlFor="tgg-title-3-1">
                      Comprehensive eye care, on the house
                      <span className="arrow-icon">
                        <img src={arrowIcon} alt="arrow-icon" />
                      </span>
                    </label>
                  </div>
                  <div className="faq-accordion-content">
                    <div className="paragraph">
                      <div className="content">
                        Uncontrolled blood sugar can lead to serious eye
                        complications — but early detection makes a difference.
                        Through our partnership with{" "}
                        <span className="bold">MOG Eyewear Malaysia</span>, we
                        offer a{" "}
                        <span className="bold">
                          FREE 6-in-1 Vision Experience
                        </span>{" "}
                        (worth RM350) at 44 participating outlets nationwide.
                      </div>
                      <br />
                      <div className="content">
                        This 20-40 minute session combines expert consultation
                        and cutting-edge eye assessments to help protect your
                        vision and detect issues early.
                      </div>
                      <div className="content checklist">
                        <ul
                          style={{ listStyleType: "none", display: "grid" }}
                          className="check"
                        >
                          <li>Personalised consultation</li>
                          <li>Eye health screening with advanced equipment</li>
                          <li>
                            Tailored vision correction and lens recommendation
                          </li>
                          <li>Digital eyewear fitting and long-term support</li>
                        </ul>
                      </div>
                      <div className="content">
                        Find out more and book an appointment{" "}
                        <a
                          href="https://appointment.mog.com.my/Sun-Life"
                          className="link p-0"
                        >
                          here
                        </a>
                        .
                      </div>
                    </div>
                  </div>
                </article>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default Faq;
